"use client";

import { ReactNode } from "react";

interface OnboardingEligibilityMessageProps {
  message: ReactNode;
}

/**
 * Reusable component for displaying eligibility messages in onboarding steps
 * Used across CEX and Social steps to show trading eligibility status
 */
export const OnboardingEligibilityMessage = ({ message }: OnboardingEligibilityMessageProps) => {
  return (
    <div className="px-4 py-3 bg-cede-primary/10 border border-cede-primary/30 rounded-lg backdrop-blur-sm">
      <div className="flex items-center justify-center">
        <p className="text-cede-primary text-sm font-semibold text-center">{message}</p>
      </div>
    </div>
  );
};
